const tables = [
  {
    name: "Date",
  },
  {
    name: "Transaction Type",
  },
  {
    name: "Amount",
  },
  {
    name: "Previous Balance",
  },
  {
    name: "New Balance",
  },
  {
    name: "Payment Method",
  },
  {
    name: "Reference Number",
  },
  {
    name: "Description",
  },
  {
    name: "Created By",
  },
];

export default tables;